import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=1b31de1a&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b31de1a')) {
      api.createRecord('1b31de1a', component.options)
    } else {
      api.reload('1b31de1a', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=1b31de1a&", function () {
      api.rerender('1b31de1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I1iWLw9P1ob4/JS/pricelisthelp.vue"
export default component.exports